import axios from "../axios-auth";

export const emrUsageHistoryService = {
    getEMRUsageHistoryList,
};


function getEMRUsageHistoryList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy,
    };

    if (searchParams.emrDetailId) {
        params["emrDetailId"] = searchParams.emrDetailId;
    }

    return axios.get("/auth/emr-usage-histories", { params });
}